  import './LmsTecResultAllimjang.scss';
  import * as S from '../scss/theme';
  import React, { useState, useEffect, useRef } from "react";
  import fnc from '../mymod/commFunction';
  import fnc3 from '../mymod/commFunction3';
  import Button from '@mui/material/Button';
  import { useDispatch, useSelector } from 'react-redux';
  import { setLessonDate, setIsModal, setLmsListCode } from '../reduxToolkit/redux';
  import DatePicker from "react-datepicker";
  import "react-datepicker/dist/react-datepicker.css";
  import LmsTecResultAllimjang_report from './LmsTecResultAllimjang_report';
  import { Checkbox } from '@mui/material';
  import { toPng, toJpeg } from 'html-to-image';
  import CircularProgressWithLabel from '../comm/CircularProgressWithLabel'; // Progress 컴포넌트 임포트
  import SmsResult from '../page_smsResult/SmsResult';
  import { sendDirectMessage } from '../page_firebase/directMessage/directMessage';

  // import Radio from '@mui/material/Radio';
  // import RadioGroup from '@mui/material/RadioGroup';
  // import FormControlLabel from '@mui/material/FormControlLabel';
  import LmsTecResultAllimjang_report_sendMenu from './LmsTecResultAllimjang_report_sendMenu';


  const LmsTecResultAllimjang = ({kind}) => {
      const smsFolder = process.env.REACT_APP_smsFolder;
      const sendPhoneNumber = process.env.REACT_APP_sendPhone;

      const dispatch = useDispatch();
      const isModal = useSelector((state) => state.reduxStore.isModal);
      const classCode = useSelector((state) => state.reduxStore.classCode);
      const isRefresh_lmsTecList = useSelector((state) => state.reduxStore.isRefresh_lmsTecList);
      const userInfo = useSelector((state) => state.reduxStore.userInfo);

      const [list, setList] = useState([]);
      const [startDate, setStartDate] = useState(new Date());
      const [isButtonDisabled, setIsButtonDisabled] = useState(false);
      const [monthInfo, setMonthInfo] = useState('');
      const [selectedItem, setSelectedItem] = useState(null);

      // const [selectedItems, setSelectedItems] = useState([]);//체크박스
      // const [selectAll, setSelectAll] = useState(false);//체크박스
      const [isSelectAll, setIsSelectAll] = useState(false);//체크박스

      const [loading, setLoading] = useState(false);
      const [optValueTarget, setOptValueTarget] = React.useState('all'); 
      const [optValueSchedule, setOptValueSchedule] = React.useState('reserve'); 
      const [sendDate, setSendDate] = useState(new Date());
      const [sendTime, setSendTime] = useState(new Date());
      const [progress, setProgress] = useState(0); // 초기 진행률 0%
      
      const [isModal_smsResult, setIsModal_smsResult] = useState(false);
      
      // Talk 전송을 위한 상태 추가
      const [sendingTalk, setSendingTalk] = useState(false);
      const [talkResults, setTalkResults] = useState([]);

      const captureRef = useRef();
      
        
      const monthInterval = 1;

    
      useEffect(() => {
        fncSelect_list();
      }, [classCode]);

      useEffect(() => {
        fncSelect_list();
        const selectedDate = fnc.formatDate(startDate);
        const weekday = fnc.getWeekDay(selectedDate);
        setMonthInfo(`${selectedDate} (${weekday})`);
    
      }, [startDate]);
    
      
    function fncSelect_list() {
      const acaCode = fnc.getCookie('acaCode');
      const stCode = fnc.getCookie('stCode');
      const lessonDate = fnc.formatDate(startDate);
      fnc.sendAxios('/select/lmsTecResultAllimjang/attendByClass', 
            { acaCode, classCode, kind, startDate, lessonDate }, (res) => {
        if (res && Array.isArray(res)) { 

          setIsSelectAll(false);
          setList(getRecords(res));

        } else {
          console.log(res,"kuesbLmsTecResult_allimjangRoutes/select/lmsTecResultAllimjang/attendByClass");
        }
      });
    }

    function getRecords(res) {
      let records = [];
      res.forEach(item => {
          const snoSt = item["snoSt"];
          const lessonDate = item["lessonDate"]; // list 코드 parent Code로 사용
          const stId = item["id"];
          const stCode = item["stCode"];
          const name = item["name"];
          let hp = item["hp"];
          hp = fnc.formatPhoneNumber(hp);
          let hpParent = item["hpParent"];
          hpParent = fnc.formatPhoneNumber(hpParent);
          const parentId = item["parentId"] || '';
          const parentName = item["parentName"] || `${name} 학부모`;
          const parentPhone = item["parentPhone"] || hpParent;
          const parentRegisteredYn = item["parentRegisteredYn"] || 'N';
          const classCode = item["classCode"];
          const className = item["className"];
          const kind = item["kind"];
          let checkedynSt = item["checkedynSt"];
          checkedynSt = fncCheckedynSt(checkedynSt);
          let eDate = item["eDate"];
          const confirmed = item["confirmed"];
          const weekDay = fnc.getWeekDay(lessonDate);
          const gangsaCode = item["gangsaCode"];
          const gangsaName = item["gangsaName"];
    
          const id = snoSt;
          const isChecked = false;//getRecords에서

          records.push({ snoSt, lessonDate, weekDay, stId, stCode, name, hp, hpParent, parentId, parentName, parentPhone, parentRegisteredYn, classCode, className, 
            kind, checkedynSt, eDate, confirmed, gangsaCode, gangsaName, isChecked, id });
      });
      return records;
  }



    
    function onRefresh() {
      if (isButtonDisabled) return; // 버튼이 비활성화되어 있는 경우 아무것도 하지 않음
      fncSelect_list();
      // 버튼 비활성화 및 일정 시간 후 재활성화
      setIsButtonDisabled(true);
      setTimeout(() => setIsButtonDisabled(false), 2000); // 2초 후 버튼 재활성화
    }

  //------------------------------------------

    
    function moveDay(currDate, days) {
      const newStartDate = fnc.moveDay(currDate, days)
      setStartDate(newStartDate);
    }

    function onClickRow(item) {
      setSelectedItem(item);
    }

    function onSendSms() {

      simulateRowClicks();

      // onCreatImg_blob();//지우지 말 것
      // onCreatImg();//지우지 말 것
      // alert('준비 중입니다.');
    }

    
    //-------------------------rowClick
  // row들을 차례대로 클릭하는 함수

  const simulateRowClicks = async () => {
    const checkedCnt = list.filter(item => item.isChecked === true).length;
    // if (checkedCnt === 0){
    //   alert('대상을 체크하세요!');
    //   return null;
    // }
    
    if (!optValueTarget) return alert('학생 또는 부모를 선택하세요!'), null;
    if (!optValueSchedule) return alert('즉시 또는 예약을 선택하세요!'), null;
    if (!checkedCnt) return alert('대상을 체크하세요!'), null;


    const rtn = window.confirm(`${checkedCnt}명의 학생에게 문자를 전송하시겠습니까?`);
    if (!rtn) return;

    setProgress(0);
    setProgress(0.01);//처음에 show하기 위해
    for (let index = 0; index < list.length; index++) {

        if (list[index].isChecked) {

          const item = list[index];
          // 1초 대기 후 row 클릭
          await new Promise((resolve) => setTimeout(resolve, 1000));
          onClickRow(item); // 해당 row 클릭  
          // 0.5초 대기 후 이미지 생성
          await new Promise((resolve) => setTimeout(resolve, 500));
          await onCreatImg_blob(item, index); // 이미지 생성 및 서버 전송

          // 진행률 업데이트 (완료된 항목 / 총 항목 수 * 100)
          setProgress((prevProgress) => prevProgress + (1 / checkedCnt) * 100);
        }
    
    }

        setProgress(100);

        setTimeout(() => {
          setProgress(0);
        }, [1000]);
    
  };


  //--------------------------------------------------------------to image
  const onCreatImg_blob = (item, index) => {
    return new Promise((resolve, reject) => {

    setLoading(true); // 로딩 상태 시작

    if (captureRef.current === null) {
      setLoading(false);
      return;
    }

    // 스크롤바를 숨기기 위한 스타일 변경
    const originalOverflow = captureRef.current.style.overflow;
    const originalHeight = captureRef.current.style.height; // 기존 높이 값 저장
    captureRef.current.style.overflow = 'hidden';
    captureRef.current.style.height = 'auto';

    const scale = 1; // 해상도 배율을 2배로 설정 (sk가 해상도 기준이 2000*2000이라 1로 수정)
    const width = captureRef.current.offsetWidth * scale;
    const height = captureRef.current.scrollHeight * scale; // 전체 높이 사용

    // // toPng로 이미지 생성 및 Blob 변환
    // toPng(captureRef.current, {
    //   skipFonts: true,
    //   filter: (node) => {
    //     // classList가 없는 요소와 custom-spinner-container 클래스를 포함하지 않은 모든 요소를 캡처에 포함
    //     return !node.classList || !node.classList.contains('custom-spinner-container');
    //   },
    //   canvasWidth: width,
    //   canvasHeight: height,
    //   pixelRatio: scale, // 해상도를 높이기 위해 픽셀 비율을 설정
    // })

    // toJpeg로 이미지 생성 및 Blob 변환
    toJpeg(captureRef.current, {
      skipFonts: true,
      filter: (node) => {
        // classList가 없는 요소와 custom-spinner-container 클래스를 포함하지 않은 모든 요소를 캡처에 포함
        return !node.classList || !node.classList.contains('custom-spinner-container');
      },
      canvasWidth: width,
      canvasHeight: height,
      pixelRatio: scale, // 해상도를 높이기 위해 픽셀 비율을 설정
      quality: 0.95 // JPEG 이미지 품질 설정 (0 ~ 1 사이 값)
    })
    
      .then((dataUrl) => {
        // dataUrl을 Blob으로 변환
        const byteString = atob(dataUrl.split(',')[1]); // Base64 문자열 분리
        const mimeString = dataUrl.split(',')[0].split(':')[1].split(';')[0]; // MIME 타입 추출

        // Blob 데이터 생성
        const ab = new ArrayBuffer(byteString.length);
        const ia = new Uint8Array(ab);
        for (let i = 0; i < byteString.length; i++) {
          ia[i] = byteString.charCodeAt(i);
        }

        return new Blob([ab], { type: mimeString });
      })
      .then((blob) => {
        const formData = new FormData();
        const currDate = fnc.fncSirialNum('S');
        const fileName = `${item.stCode}.jpg`;//SMS png 안 돼
        const smsFileName = `${currDate}_${fileName}`;
      
        //formData.append('classCode', currDate);  // 추가 데이터 (예: classCode)
        formData.append('file', blob, fileName);  // Blob 파일 추가
        formData.append('s3Key', `public/sms/${smsFileName}`);
        // 파일 업로드 요청
        fnc.sendAxios('/uploadS3', formData, (res) => {//이미지파일 S3에 업로드
          if (res) {
            setTimeout(() => {
              fncSendSMS(smsFileName, item, index);//레코드에 입력
              resolve();  // 성공 시 Promise 완료
            }, 1000);  
          
          } else {
            console.log('kuesbSftpRoutes/Error during file upload');
            reject('Error during file upload');
          }
        });


      })
      .catch((err) => {
        console.error('Error capturing image or sending to server', err); // 에러 처리
      })
      .finally(() => {
        setLoading(false); // 로딩 상태 종료
        captureRef.current.style.overflow = originalOverflow; // 원래 overflow 상태로 복원
        captureRef.current.style.height = originalHeight; // 원래 height로 복원
      });

    });
  };



  function fncSendSMS(fileName, item, index) {
    const acaCode = fnc.getCookie('acaCode');
    const stCode = fnc.getCookie('stCode');
    const MSG='고대학원';
    const SUBJECT = '일일리포트';
    const category = '일일리포트';
    const FILE_CNT = 1;
  // const FILE_PATH1 = `${smsFolder}/${fileName}`;//smsFolder;// `http://kuesb.i234.me/kuesbLmsFileUpload/sms/${fileName}`;//https(안 돼)
  // const FILE_PATH1 = fnc3.getS3Path( `${smsFolder}/${fileName}`);
    const FILE_PATH1 =  `${smsFolder}/${fileName}`;
    const sendPhone = sendPhoneNumber;//'01093871431';
    let mode = '';
    const sendUserName = fnc.getCookie('userName');

    let sendDateTime = '';

    if (optValueSchedule == 'now') {//즉시 예약
        sendDateTime = fnc.getNow();
        mode='즉시';
    } else {
        sendDateTime =`${fnc.formatDate(sendDate)} ${fnc.formatTime(sendTime)}`;
        mode='예약';
    }

    // return;
    // 대상 정보를 담은 객체
    let targetList = [];

    // optValueTarget에 따라 처리
    if (optValueTarget === 'student' || optValueTarget === 'all') {
      // 학생 정보가 유효한 경우 추가
      if (item.hp && item.hp.trim() !== '') {
        targetList.push({ name: item.name, phone: item.hp });
      }
    }

    if (optValueTarget === 'parent' || optValueTarget === 'all') {
      // 부모 정보가 유효한 경우 추가
      if (item.hpParent && item.hpParent.trim() !== '') {
        targetList.push({ name: `${item.name} 학부모`, phone: item.hpParent });
      }
    }


    // 대상이 없으면 함수 종료
    if (targetList.length === 0) {
      console.log("전화번호가 모두 공백입니다. SMS를 보내지 않습니다.");
      return;  // 아무것도 하지 않고 종료
    }

    // 각각의 대상에게 SMS 전송
    targetList.forEach(target => {
      fnc.sendAxios('/kuesbSmsRoutes/insert/mms', { 
        SUBJECT, 
        MSG,  
        FILE_CNT,
        FILE_PATH1,
        PHONE: target.phone,  // 대상의 전화번호
        sendPhone,
        sendDateTime,
        acaCode,
        stCode,
        stName: target.name,  // 대상의 이름 (학생 혹은 '학생 이름 학부모')
        mode, //즉시/예약
        sendUserName,
        category//항목 
      }, (res) => {
        console.log(res, Array.isArray(res) ? 'sms' : "kuesbSms/insert/sms");
      });
    });

  
  }

  //Talk으로 이미지 전송하기

   // 일괄 이미지 메시지 전송
      const handleSendBulkImageMessage = async () => {
          // 체크된 학생들 필터링
          const checkedStudents = list.filter(item => item.isChecked === true);
          
          if (checkedStudents.length === 0) {
              alert('전송할 학생을 선택해주세요.');
              return;
          }

          if (!optValueTarget) {
              alert('학생 또는 부모를 선택하세요!');
              return;
          }

          const rtn = window.confirm(`${checkedStudents.length}명의 학생에게 Talk 이미지를 전송하시겠습니까?`);
          if (!rtn) return;

          setSendingTalk(true);
          setTalkResults([]);
          setProgress(0);
          setProgress(0.01); // 처음에 show하기 위해

          const certCode = fnc.getCookie('certCode') || '';
          const acaCode = certCode;
          
          // 발신자 정보
          const SENDER_ID = `${acaCode}_${userInfo?.id || ''}`;
          const SENDER_NAME = userInfo?.name || '';
          const chatRoomName = `AI K-EDU 학원`;
          
          const sendResults = [];

          try {
              for (let index = 0; index < checkedStudents.length; index++) {
                  const student = checkedStudents[index];
                  
                  try {
                      // 각 학생에 대해 이미지 생성 및 전송
                      await handleSingleStudentImageMessage(student, {
                          acaCode,
                          SENDER_ID, 
                          SENDER_NAME,
                          chatRoomName
                      }, sendResults);

                      // 진행률 업데이트
                      setProgress((prevProgress) => prevProgress + (1 / checkedStudents.length) * 100);

                  } catch (error) {
                      console.error(`${student.name} 전송 실패:`, error);
                      sendResults.push({
                          student: student,
                          success: false,
                          message: `전송 실패: ${error.message}`
                      });
                  }

                  // 각 전송 후 잠시 대기 (Firebase 부하 방지)
                  await new Promise(resolve => setTimeout(resolve, 500));
              }

              setTalkResults(sendResults);
              
              const successCount = sendResults.filter(r => r.success).length;
              const totalCount = sendResults.length;
              
              if (successCount === totalCount) {
                  alert(`모든 Talk 메시지가 성공적으로 전송되었습니다. (${successCount}/${totalCount})`);
              } else {
                  alert(`일부 Talk 메시지 전송에 실패했습니다. (성공: ${successCount}/${totalCount})`);
              }

              setProgress(100);
              setTimeout(() => {
                  setProgress(0);
              }, 1000);

          } catch (error) {
              console.error('일괄 Talk 이미지 전송 중 오류:', error);
              alert('Talk 이미지 전송 중 오류가 발생했습니다.');
          } finally {
              setSendingTalk(false);
          }
      };

      // 개별 학생에게 이미지 메시지 전송
      const handleSingleStudentImageMessage = async (student, senderInfo, sendResults) => {
          return new Promise(async (resolve, reject) => {
              try {
                  // 해당 학생으로 selectedItem 설정하여 리포트 생성
                  setSelectedItem(student);
                  
                  // 잠시 대기 후 이미지 생성
                  await new Promise((resolve) => setTimeout(resolve, 500));
                  
                  // 이미지 생성
                  const imageBlob = await generateImageForStudent(student);
                  
                  if (!imageBlob) {
                      throw new Error('이미지 생성에 실패했습니다.');
                  }

                  // Firebase Storage에 이미지 업로드
                  const downloadURL = await uploadImageToFirebase(imageBlob, student);
                  
                  const imageData = [{
                      url: downloadURL,
                      name: `${student.stCode}_report.jpg`,
                      size: imageBlob.size,
                      type: 'image'
                  }];

                  // 대상 학생/부모 정보 생성
                  const targetList = createTargetList(student, senderInfo.acaCode);

                  if (targetList.length === 0) {
                      throw new Error('선택한 TALK 대상의 수신 정보가 없습니다.');
                  }

                  await ensureGuardianTalkTargets(targetList, senderInfo.acaCode);

                  // 각 대상에게 메시지 전송
                  for (const target of targetList) {
                      try {
                          const response = await sendDirectMessage(
                              senderInfo.chatRoomName,
                              senderInfo.SENDER_ID,
                              senderInfo.SENDER_NAME,
                              target.receiverId,
                              '일일리포트',
                              'image',
                              imageData,
                              getTalkOptions(target, senderInfo.chatRoomName)
                          );

                          sendResults.push({
                              student: student,
                              target: target.name,
                              success: response.success,
                              message: response.success ? '전송 성공' : `전송 실패: ${response.error}`,
                              messageId: response.messageId,
                              chatRoomId: response.chatRoomId
                          });
                      } catch (error) {
                          sendResults.push({
                              student: student,
                              target: target.name,
                              success: false,
                              message: `전송 실패: ${error.message}`
                          });
                      }
                  }

                  resolve();
              } catch (error) {
                  reject(error);
              }
          });
      };

      // 학생에 대한 이미지 생성
      const generateImageForStudent = (student) => {
          return new Promise((resolve, reject) => {
              if (captureRef.current === null) {
                  reject(new Error('캡처 대상이 없습니다.'));
                  return;
              }

              // 스크롤바를 숨기기 위한 스타일 변경
              const originalOverflow = captureRef.current.style.overflow;
              const originalHeight = captureRef.current.style.height;
              captureRef.current.style.overflow = 'hidden';
              captureRef.current.style.height = 'auto';

              const scale = 1;
              const width = captureRef.current.offsetWidth * scale;
              const height = captureRef.current.scrollHeight * scale;

              toJpeg(captureRef.current, {
                  skipFonts: true,
                  filter: (node) => {
                      return !node.classList || !node.classList.contains('custom-spinner-container');
                  },
                  canvasWidth: width,
                  canvasHeight: height,
                  pixelRatio: scale,
                  quality: 0.95
              })
              .then((dataUrl) => {
                  const byteString = atob(dataUrl.split(',')[1]);
                  const mimeString = dataUrl.split(',')[0].split(':')[1].split(';')[0];

                  const ab = new ArrayBuffer(byteString.length);
                  const ia = new Uint8Array(ab);
                  for (let i = 0; i < byteString.length; i++) {
                      ia[i] = byteString.charCodeAt(i);
                  }

                  const blob = new Blob([ab], { type: mimeString });
                  resolve(blob);
              })
              .catch((err) => {
                  reject(err);
              })
              .finally(() => {
                  captureRef.current.style.overflow = originalOverflow;
                  captureRef.current.style.height = originalHeight;
              });
          });
      };

      // Firebase Storage에 이미지 업로드
      const uploadImageToFirebase = async (imageBlob, student) => {
          const { ref: storageRef, uploadBytesResumable, getDownloadURL } = await import('firebase/storage');
          const { storage } = await import('../page_firebase/firebaseConfig');
          
          const timestamp = Date.now();
          const randomId = Math.random().toString(36).substring(2, 9);
          const fileName = `images/report_${timestamp}_${randomId}_${student.stCode}.jpg`;
          const imageRef = storageRef(storage, fileName);
          
          const uploadTask = uploadBytesResumable(imageRef, imageBlob);
          
          return new Promise((resolve, reject) => {
              uploadTask.on(
                  'state_changed',
                  (snapshot) => {
                      const progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
                      console.log(`${student.name} 이미지 업로드 진행률: ${progress}%`);
                  },
                  (error) => {
                      console.error('이미지 업로드 실패:', error);
                      reject(error);
                  },
                  async () => {
                      const url = await getDownloadURL(uploadTask.snapshot.ref);
                      resolve(url);
                  }
              );
          });
      };

      // 대상 목록 생성 (학생/부모)
      const normalizePhone = (value) => String(value || '').replace(/[^0-9]/g, '');

      const sendAxiosPromise = (url, payload) => new Promise((resolve) => {
          fnc.sendAxios(url, payload, (res) => resolve(res));
      });

      const createTargetList = (student, acaCode) => {
          let targetList = [];

          if ((optValueTarget === 'student' || optValueTarget === 'all') && student.stId) {
              targetList.push({ 
                  name: student.name, 
                  label: '학생',
                  kind: 'student',
                  receiverId: `${acaCode}_${student.stId}`,
                  student
              });
          }

          if (optValueTarget === 'parent' || optValueTarget === 'all') {
              const parentPhone = normalizePhone(student.parentPhone || student.hpParent);
              const receiverId = parentPhone ? `${acaCode}_P_${parentPhone}` : '';

              if (receiverId && parentPhone) {
                  targetList.push({
                      name: student.parentName || `${student.name} 학부모`,
                      label: '부모',
                      kind: 'parent',
                      receiverId,
                      parentPhone,
                      student
                  });
              }
          }

          return targetList;
      };

      const ensureGuardianTalkTargets = async (targetList, acaCode) => {
          const guardians = targetList
              .filter((target) => target.kind === 'parent' && target.student?.stId)
              .map((target) => ({
                  studentId: target.student.stId,
                  studentStCode: target.student.stCode || 0,
                  studentName: target.student.name || '',
                  guardianId: target.receiverId,
                  guardianName: target.name,
                  guardianPhone: target.parentPhone,
                  relation: 'parent',
                  status: 'pending',
                  isPrimary: 'Y'
              }));

          if (!guardians.length) return;

          const syncResult = await sendAxiosPromise('/socialLoginRoutes/upsert/guardianTalkTargets', {
              acaCode,
              guardians
          });

          if (syncResult?.failed?.length) {
              console.warn('[AllimjangTalk] 일부 학부모 매칭 저장 실패:', syncResult.failed);
          }
      };

      const getTalkOptions = (target, chatRoomName) => {
          if (target.kind !== 'parent') return {};

          const studentId = target.student?.stId || target.student?.stCode || '';
          const studentName = target.student?.name || '';
          return {
              targetRole: 'parent',
              contextType: 'student',
              contextId: studentId,
              contextKey: `student_${studentId}`,
              studentId,
              studentName,
              roomName: `${chatRoomName} - ${studentName} 학부모`
          };
      };
  


    //=========================================
      return (
      <>
        <div className="LmsTecResultAllimjang">

        
          {!!progress && <div className='box-progress'>  {/* Progress 표시 */}
              <CircularProgressWithLabel value={progress} />
          </div> }
          
          <div className="wrap-main">
            <section className="section-main">
              <table className="table-hong table-main">
                <thead>
                  <tr>
                    <th>No</th>
                    <th>
                      <Checkbox    
                          className="custom-checkbox"
                          checked={isSelectAll}
                          onChange={handleSelectAllChange} 
                      />
                    </th>
                    <th>성명</th>
                    <th>HP학생</th>
                    <th>HP부모</th>
                    {/* <th>수업일</th> */}
        
    
                  </tr>
                </thead>

                <tbody>
                    {list && list.map((item, index) => (
    
                        <tr key={index} onClick={() => onClickRow(item)}>  
                          <td>{index+1}</td>

                          <td>
                              <Checkbox
                              className="custom-checkbox"
                              checked={item.isChecked}
                              onChange={(event) => handleCheckboxChange(event, index)} />
                          </td>

                          <td>
                              <p className='name'> {item.name}</p>
                          </td>
                  
                          <td>
                            <span className='hp'> {item.hp}</span> 
                          </td>
                          <td>
                            <span className='hpParent'>{item.hpParent}</span>
                          </td>

                          {/* <td>
                              <p> {item.lessonDate} ({item.weekDay})</p>
                          </td> */}
          
                        </tr>
                    ))}
              
                  </tbody>
              </table>
            </section>

            <section className='section-reportChart' >
            {<LmsTecResultAllimjang_report selectedItem={selectedItem}  ref={captureRef} /> }

            <article className='article-sendMenu'>
                  <LmsTecResultAllimjang_report_sendMenu 
                    optValueTarget={optValueTarget} setOptValueTarget={setOptValueTarget} 
                    optValueSchedule={optValueSchedule} setOptValueSchedule={setOptValueSchedule}
                    sendDate={sendDate} setSendDate={setSendDate}
                    sendTime={sendTime} setSendTime={setSendTime}
                  />
                
                
              </article>
            
            </section>

          
        
          </div>

          <section className='section-menu'>

            {/* <p className='stName'>{selectedItem?.name}</p> */}
            {/* <p className='monthInfo'>{monthInfo}</p> */}


            <Button className='btnNextPrev' onClick={() => moveDay(startDate, - 1)}>
              <i className="fas fa-backward"></i> 
            </Button>

            <DatePicker
                selected={startDate}
                onChange={(date) => {setStartDate(date)}}
                dateFormat="yyyy-MM-dd"
                className="datePicker"
                enableTabLoop={false}//클릭시 오른쪽 밀림 방지
              />


            <Button className='btnNextPrev' onClick={() => moveDay(new Date(), 0)}>
              <i className="fas fa-pause"></i>
            </Button>

            <Button className='btnNextPrev' onClick={() => moveDay(startDate, 1)}>
              <i className="fas fa-forward"></i>
            </Button>

            

            <section className='section-smsMenu'>

              <Button className='btnRefresh h-btn-gray' onClick={onRefresh} disabled={isButtonDisabled}> 
                <i className="fas fas fa-sync"></i> 
                새로고침
              </Button>

                <Button className='btnSendSms h-btn-red' onClick={onSendSms}> 
                    <i class="fa-solid fa-mobile-retro"></i>문자전송
                </Button>

                <Button className='btnSmsHistory h-btn-green' onClick={() => setIsModal_smsResult(true)}> 
                    <i class="fa-solid fa-mobile-retro"></i>문자내역
                </Button>

                <Button className='btnSmsHistory h-btn-blue' onClick={handleSendBulkImageMessage} disabled={sendingTalk}> 
                    <i className="fa-solid fa-mobile-retro"></i>
                    {sendingTalk ? 'TALK 전송 중...' : 'TALK 전송'}
                </Button>
            </section>

          </section>

        

        </div>

      {isModal_smsResult && 
        <S.Modal_fullScreen backgroundColor='white'>
          <SmsResult  setIsModal={setIsModal_smsResult} />
        </S.Modal_fullScreen>
        }

  </>
      );

      //------------------------------------------------------


      
    //---------------------------checkbox
    function handleCheckboxChange(event, index) {
      const isChecked = event.target.checked;
      // console.log(isChecked, 'isChecked');
      const newList = [...list];
      newList[index].isChecked = isChecked;
      setList(newList);
  
    // 모두 체크되었는지 확인하여 헤더 체크박스 상태 업데이트
    const allChecked = newList.every(item => item.isChecked);
    setIsSelectAll(allChecked);
    }

    function handleSelectAllChange() {

      const newList = list.map(item => ({...item, isChecked: !isSelectAll }));
      setList(newList);
      setIsSelectAll(!isSelectAll);
    }//checkbox END

      
    function fncCheckedynSt(checkedynSt) {
      switch(checkedynSt) {

        case 'Y':
          return '출석';
          break;  
      
        case 'L':
          return '지각';
          break;

        default:
          return '결석';
          break;
    
      }
    }
    
      
  }

  export default LmsTecResultAllimjang;
